import * as yup from "yup";
import { ptForm } from "yup-locale-pt";

yup.setLocale(ptForm);

export default yup;
